export const parseTime = value => {
  if (value === '' || value === null) {
    return {
      hours: 0,
      minutes: 0
    };
  }
  const timeParts = value.split(':');
  const hours = parseInt(timeParts[0] ?? '00');
  const minutes = parseInt(timeParts[1] ?? '00');
  if (isNaN(hours) || hours > 23 || hours < 0) {
    return {
      hours: 0,
      minutes: 0
    };
  }
  if (isNaN(minutes) || minutes > 59 || minutes < 0) {
    return {
      hours: 0,
      minutes: 0
    };
  }
  return {
    hours,
    minutes
  };
};
const pad = value => {
  return value.toString().padStart(2, '0');
};
export const stringifyTime = (hour, minute) => {
  return `${pad(hour)}:${pad(minute)}:00`;
};
export const stringifyHour = (hour, is24) => {
  if (is24) {
    return pad(hour);
  }
  if (hour === 0 || hour === 12) {
    return '12';
  }
  return pad(hour % 12);
};
export const stringifyHourFace = hour => {
  return hour === 0 ? '12' : hour === 12 ? '24' : String(hour);
};
export const stringifyMinute = minute => {
  return pad(minute);
};
export const hourToIndex = (hour, is24) => {
  if (is24) {
    if (hour === 0) {
      return 12;
    }
    if (hour === 12) {
      return 0;
    }
    return hour;
  }
  return hour % 12;
};
export const getNeedleRotationDeg = elem => {
  const match = elem.style.transform.match(/^rotate\((-?\d+)deg\)$/);
  if (match === null) {
    return 0;
  }
  return Number(match[1]);
};
export const getShortestCssDeg = (currentDeg, nextDeg) => {
  const angle = currentDeg % 360;
  const diff = (360 - (angle - nextDeg)) % 360;
  if (diff > 180) {
    return currentDeg - 360 + diff;
  }
  return currentDeg + diff;
};